import React from "react";
import { DrawerContentScrollView } from "@react-navigation/drawer";
import { View, Text, TouchableOpacity, StyleSheet, Image } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useProfile } from "../hooks/Profile/useProfile";


const drawerItems = [
  { label: "Home", icon: "home-outline", screen: "Home" },
  { label: "Report", icon: "notebook", screen: "Report" },
  { label: "Requests", icon: "briefcase-search", screen: "Request" },
  { label: "My Profile", icon: "account-outline", screen: "Perfil" },
  // { label: "Log Out", icon: "logout", screen: "Log Out" },
];

const CustomDrawerContent = (props: any) => {
  const { user, logout } = useProfile();
  const activeIndex = props.state.index;

  return (
    <DrawerContentScrollView {...props} contentContainerStyle={styles.container}>
      {drawerItems.map((item, index) => {
        const focused = index === activeIndex;

        return (
          <TouchableOpacity
            key={item.screen}
            style={[styles.item, focused && styles.activeItem]}
            onPress={
              item.screen === "Log Out" 
                ? logout // Call logout function for "Log Out"
                : () => props.navigation.navigate(item.screen)
            }
          >
            {item.icon ? (
              <MaterialCommunityIcons
                name={item.icon as keyof typeof MaterialCommunityIcons.glyphMap}
                size={32}
                color={focused ? "#0f8ff9" : "#777"}
              />
            ) : null}
            <Text style={[styles.label, focused && styles.activeLabel]}>
              {item.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </DrawerContentScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
  },
  logoContainer: {
    alignItems: "center",
    marginBottom: 20,
  },
  logo: {
    width: 120,
    height: 60,
  },
  item: {
    alignItems: "center",
    marginVertical: 10,
    padding: 10,
    minHeight: 80, // Consistent height
    justifyContent: "center",
  },
  label: {
    fontSize: 14,
    color: "#777",
    marginTop: 4,
  },
  activeItem: {
    backgroundColor: "#2cb4fc17",
    borderRadius: 6,
  },
  activeLabel: {
    color: "#0f8ff9"
  },
});

export default CustomDrawerContent;
